exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AssessmentOverview-module__wrapper___22CuO{display:grid;grid-template-columns:1fr;gap:1.5rem}@media screen and (min-width:525px){.AssessmentOverview-module__wrapper___22CuO{grid-template-columns:repeat(auto-fill,minmax(400px,1fr))}}.AssessmentOverview-module__secondary-title___dGQVe{margin-top:2rem;margin-bottom:1rem}.AssessmentOverview-module__secondary-title___dGQVe:first-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"wrapper": "AssessmentOverview-module__wrapper___22CuO",
	"secondary-title": "AssessmentOverview-module__secondary-title___dGQVe"
};